var ProtocolConfigurationService = (function () {
    function ProtocolConfigurationService($http) {
        this.$http = $http;
    }
    ProtocolConfigurationService.prototype.get = function () {
        return this.$http
            .get('compatibilityguide/ng-settings/feature/search/protocoloptions')
            .then(function (response) { return response.data; });
    };
    ProtocolConfigurationService.$inject = ['$http'];
    return ProtocolConfigurationService;
}());
export { ProtocolConfigurationService };
